export const pageOpenedInIFrame = () => window.location !== window.parent.location;
export const forceHttps = (url: string) => url;
